import type { App } from "vue";
import router from "../router";
import i18n from "./i18n";
import vuetify from "./vuetify";

export function registerPlugins(app: App): void {
  app.use(vuetify);
  app.use(router);
  app.use(i18n);
}
